module.exports = __webpack_public_path__ + "242260a73a1b7676d8b4c34ccf1c6b46.jpg";